/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2021-06-03 20:31:01
 * @LastEditors: sjq
 * @LastEditTime: 2021-09-13 18:15:45
 */
export const enterNumber = {
  //全局方法  限制input输入框只能输入纯数字 组件中调用如（<el-input v-enter-number v-model="number" ></el-input>）
  inserted: function(el) {
    el.addEventListener('keypress', function(e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      // console.log(e)
      let re = /\d|\./
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
    // el.addEventListener('input', function(e) {
    //   e = e || window.event
    //   let charcode = e.data
    //   let re = /\d|\./
    //   console.log(e, e.data, 'input', !re.test(charcode))
    //   if (!re.test(charcode)) {
    //     if (e.preventDefault) {
    //       e.preventDefault()
    //     } else {
    //       e.returnValue = false
    //     }
    //   }
    // })
  }
}
